export default __webpack_public_path__ + "img/3cec0697522485872d57a7ee42676001.apng";